import type { ComponentProps } from 'react';
import { LoadingMask } from '@zillow/constellation-10';

export function BlockLoadingMask(props: ComponentProps<typeof LoadingMask>) {
  return <LoadingMask css={{ display: 'block' }} {...props} />;
}

export function TallHeightLoadingMask(props: ComponentProps<typeof LoadingMask>) {
  return <LoadingMask css={{ display: 'block', minHeight: '70vh' }} {...props} />;
}

export function FullHeightLoadingMask(props: ComponentProps<typeof LoadingMask>) {
  return <LoadingMask css={{ display: 'block', height: '100%' }} {...props} />;
}
